import Event from './Event.js';

class TradeCostExpected extends Event {
    get trade_cost_cancel(){
        let value = (this.constructor.employeeStore.event_relations.find(rel => (rel.parent_id === this.id)&&(rel.child_type==='TradeCostCancel'))||{}).child_id
        if(value){
            return this.constructor.employeeStore.events.find(ev => (ev.id === value)&&ev.id)
        } else {
            return null
        }
    }
    get trade_cost(){
        return (this.trade_cost_cancel||{}).trade_cost
    }

    get linked(){
        return this.trade_cost_cancel != null
    }

    // TradeCostExpected should always be matched with a TradeCost
    get should_be_linked() {
        return true
    }

    get trade_expected_relation(){
        return this.constructor.employeeStore.event_relations.find(rel => (rel.child_id === this.id)&&(rel.parent_type==='TradeExpected'))||{}
    }

    get trade_expected_id(){
        if(this._trade_expected_id){return this._trade_expected_id}
        this.trade_expected_id = this.trade_expected_relation.parent_id
        return this._trade_expected_id
    }

    set trade_expected_id(value){
        this._trade_expected_id = value
    }
    get trade_expected(){
        if(this.trade_expected_id){
            return this.constructor.employeeStore.events.find(ev => ev.id === this.trade_expected_id)
        } else {
            return {}
        }
    }

    get issue(){
        return this.trade_expected.issue
    }
}
export default TradeCostExpected
